<template>
  <TabBtn
    :tabs="tabs"
    :active-tab="currentTable.value"
    height="600px"
    @tab-click="handleTabClick"
  >
    <template slot="btn">
      <el-button type="primary" size="mini" @click="handleCalculate"
        >测算最新含量</el-button
      >
      <el-button type="primary" size="mini" @click="handleInsert"
        >带入企业定额库</el-button
      >
      <el-button
        v-if="currentTable.value === 'historyDataReal'"
        type="primary"
        size="mini"
        @click="handleImportReal"
        >导入实耗人材机</el-button
      >
    </template>
    <template>
      <div class="box">
        <div class="top" v-if="currentTable.value === 'historyDataSub'">
          <SimpleTable
            width="300px"
            table-code="QuotaHistoryLeft"
            :showIndex="false"
            :loading="loading.left"
            :columns="columns.left"
            :data="tableData.left"
          />
          <SimpleTable
            table-code="QuotaHistoryRight"
            :showIndex="false"
            :loading="loading.right"
            :columns="columns.right"
            :data="tableData.right"
          />
        </div>
        <div class="bottom">
          <SimpleTable
            :showIndex="false"
            :loading="loading.bottom"
            :columns="columns.bottom"
            :data="tableData.bottom"
          />
        </div>
      </div>
    </template>
  </TabBtn>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'
import { sortRecords } from '@/utils/index'

export default {
  name: 'ImportQuota',
  inject: ['detailsVm'],
  components: {
    SimpleTable,
    TabBtn
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tabs: [
        {
          label: '历史工程结算子目',
          value: 'historyDataSub',
          columns: [
            { field: 'name', title: '编码' },
            { field: 'name', title: '类别' },
            { field: 'name', title: '人材机名称' },
            { field: 'name', title: '规格型号' },
            { field: 'name', title: '单位' },
            { field: 'name', title: '预算数量' },
            { field: 'name', title: '原有含量' },
            { field: 'name', title: '最新含量' },
            { field: 'name', title: '预算关键词' }
          ]
        },
        {
          label: '历史工程结算人材机',
          value: 'historyDataPerson',
          columns: [
            { field: 'name', title: '人材机名称' },
            { field: 'name', title: '规格型号' },
            { field: 'name', title: '单位' },
            { field: 'name', title: '预算数量' },
            { field: 'name', title: '预算关键词' },
            { field: 'name', title: '实耗人材机名称' },
            { field: 'name', title: '规格型号' },
            { field: 'name', title: '实耗数量' },
            { field: 'name', title: '实际关键词' },
            { field: 'name', title: '实耗量增减系数' }
          ]
        },
        {
          label: '历史工程实耗人材机',
          value: 'historyDataReal',
          columns: [
            { field: 'name', title: '编码' },
            { field: 'name', title: '人材机名称' },
            { field: 'name', title: '规格型号' },
            { field: 'name', title: '单位' },
            { field: 'name', title: '实耗数量' },
            { field: 'name', title: '实耗关键词' }
          ]
        }
      ],
      currentTable: {},
      loading: {
        left: false,
        right: false,
        bottom: false
      },
      tableData: {
        left: [],
        right: [],
        bottom: []
      },
      columns: {
        left: [{ field: 'name', title: '历史工程名称' }],
        right: [
          { field: 'name', title: '编码' },
          { field: 'name', title: '子目名称' },
          { field: 'name', title: '单位' },
          { field: 'name', title: '工程量' }
        ],
        bottom: []
      }
    }
  },
  watch: {
    basicInfo: {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      },
      immediate: true
    }
  },
  created() {
    this.handleTabClick(this.tabs[0])
  },
  methods: {
    init() {
      if (!this.basicInfo?.id) return
      this.getTableData()
    },

    handleTabClick(tab) {
      this.currentTable = tab
      this.columns.bottom = tab.columns
    },

    async getTableData() {
      this.loading = true
      const res = await this.$service.get('/importQuota/getTableData')
      this.tableData = sortRecords(res.data || [])
      this.loading = false
    },

    async handleCalculate() {},
    async handleInsert() {},
    async handleImportReal() {}
  }
}
</script>

<style scoped lang="less">
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  > div {
    flex: 1;
    width: 100%;
  }
  .top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
